import { Component, OnInit, Input, HostListener } from '@angular/core';
import { DocDefPrimLibService } from '../../../doc-def-prim-lib.service';
import { DOData, NJDocData, modalParams, ModalParamsElem } from "../../DOData"
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'cylib-modal-program4-user',
  templateUrl: './modal-program4-user.component.html',
  styleUrls: ['./modal-program4-user.component.css']
})
export class ModalProgram4UserComponent implements OnInit {
    @Input() modal_zip_title;
    @Input() modal_zip_content;
    public loaderKey: string = "Wrappers";
    private strDocDefTypeSubCode: string = "Wrappers";
    private Program4UserTemplateCode: string = "Wrappers_UserProgram_TOSection_UserProgram_Grid_TextBox_FromUser";
    private tab: string = "Wrappers_Tab_UserProgram";
    private gridTemplateCode: string = "Wrappers_UserProgram_TOSection_UserProgram_Grid";
    isDataAvailable: boolean = false;

    public listDocdata: Array<Array<DOData>>;
    private selectedRow: Array<DOData> = new Array<DOData>();
    validationMsgs: string = "";
    constructor(public activeModal: NgbActiveModal, private dataLib: DocDefPrimLibService) { }
    public returnResponse() {
        if (this.selectedRow.length == 0)
            this.validationMsgs = "Please select an item before clicking Accept";
        else
            this.activeModal.close(this.selectedRow);
    }
    public dismiss() {
        this.activeModal.dismiss(new Array<NJDocData>());
    }
    mobHeight: number;
    mobWidth: number;
    height: Number = 50;
    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.mobHeight = event.target.innerHeight;
        this.mobWidth = event.target.innerWidth;
        this.height = this.mobHeight * 0.5;
    }
    ngOnInit(){}
    public LoadInitData() {
        var params: modalParams = new modalParams();
        params.tabTemplateCode = this.tab;
        params.loaderKey = this.loaderKey;
        params.strDocDefTypeSubCode = this.strDocDefTypeSubCode;
        params.gridTemplateCode = this.gridTemplateCode;
        var elem: ModalParamsElem = new ModalParamsElem();
        elem.param = this.Program4UserTemplateCode;
        params.lstModalParams.push(elem);
        this.dataLib.loadTab(params)
            .subscribe(
                (ret: boolean) => {
                    if (ret) {
                        //this.listVM = this.data.WelcomeVM;
                        let localListDocdata = new Array<Array<DOData>>();
                        for (let lstData of this.dataLib.TabVM.docdata) {
                            let newLst = new Array<DOData>();
                            for (let doData of lstData) {
                                newLst.push(DocDefPrimLibService.createNew(doData));
                            }
                            localListDocdata.push(newLst)
                        }
                        this.listDocdata = localListDocdata;
                        this.isMoreThanOne();
                    }
                },
                (err: any) => console.log(err),
                () => {
                    console.log('Complete')
                    // this does not work in IE. Method used to make IE work is depricated.
                    // When we go to a real browser we should use commented out code.
                    //window.dispatchEvent(new Event('resize'));
                    //var resizeEvent = window.document.createEvent('UIEvents');
                    //resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //window.dispatchEvent(resizeEvent);

                    //var resizeEvent = window.document.createEvent('UIEvents');
                    //resizeEvent.initUIEvent('resize', true, false, window, 0);
                    //window.dispatchEvent(resizeEvent);

                    if (typeof (Event) === 'function') {
                        // modern browsers
                        window.dispatchEvent(new Event('resize'));
                    } else {
                        //This will be executed on old browsers and especially IE
                        var resizeEvent = window.document.createEvent('UIEvents');
                        resizeEvent.initUIEvent('resize', true, false, window, 0);
                        window.dispatchEvent(resizeEvent);
                    }
                    //this.ModalWait.close("");
                }
            );
    }
    isMoreThanOne() {
        // find grid
        let lstGrid = this.listDocdata[0].filter(function (item) {
            return item.njDocDefTemplate.tType.toLowerCase().includes("grid")
        });
        //find User Program code data
        let lstGridData: Array<NJDocData> = new Array<NJDocData>();
        if (lstGrid.length == 1) {
            lstGridData = lstGrid[0].lstDocData;
        }
        //count rowids   
        let getRows = [];
        for (let i: number = 0; i < lstGridData.length; i++) {
            if (getRows.indexOf(lstGridData[i].docDefDataRowID) === -1) {
                getRows.push(lstGridData[i].docDefDataRowID);
            }
        };
        if (getRows.length == 1) {
            this.selectedRow = new Array<DOData>();
            for (let i: number = 0; i < lstGrid[0].lstDocData.length; i++) {
                let item = lstGrid[0].lstDocData[i];
                let DOMessage: DOData = new DOData();
                DOMessage.njDocData = item;
                let lstTemplate = lstGrid[0].lstChildDocDefTemplate.filter(function (item1) {
                    return item1.docDefTemplateID == item.docDefTemplateID;
                });
                if (lstTemplate.length == 1) {
                    DOMessage.njDocDefTemplate = lstTemplate[0];
                }
                this.selectedRow.push(DOMessage);
            }
            this.returnResponse();
        }
        this.isDataAvailable = true;
        //console.log('zip code data count: ' + getRows.length);
    }

    onDblClickGrid(d: DOData) {

        let dataValue: string;
        //on error return empty array
        this.selectedRow = new Array<DOData>();
        // find grid
        let lstGrid = this.listDocdata[0].filter(function (item) {
            return item.njDocDefTemplate.tType == "Grid"
        });
        //find zip code data
        let lstGridData: Array<NJDocData> = new Array<NJDocData>();
        if (lstGrid.length == 1) {
            //get grid data
            lstGridData = lstGrid[0].lstDocData;
            // get selected row from col of zip key and value selected
            // find template of key from template code in custom paramater
            let templateCodeKey = lstGrid[0].customParameters.KeyColumnField;
            let lstTemplate = lstGrid[0].lstChildDocDefTemplate.filter(function (item) {
                return item.templateCode == templateCodeKey;
            });
            if (lstTemplate.length == 1) {
                // find template id of key
                let docDefTemplateID = lstTemplate[0].docDefTemplateID;
                dataValue = d.njDocData["T" + docDefTemplateID];
                // get NJDocData of selected item 
                let lstdata = lstGridData.filter(function (item) {
                    return item.docDefTemplateID == docDefTemplateID && item.dataValue == dataValue;
                });
                // get the selected row using docDefDataRowParID
                if (lstdata.length == 1) {
                    //selected row cleared above
                    for (var item of lstGridData) {
                        if (item.docDefDataRowID == lstdata[0].docDefDataRowID) {
                            let doData = new DOData();
                            doData.njDocData = item;
                            let lstTemplate = lstGrid[0].lstChildDocDefTemplate.filter(function (item1) {
                                return item1.docDefTemplateID == item.docDefTemplateID;
                            });
                            if (lstTemplate.length == 1) {
                                doData.njDocDefTemplate = lstTemplate[0];
                            }
                            doData.njDocDefTemplate
                            this.selectedRow.push(doData);
                        }
                    }
                    this.returnResponse();
                }
            }
            this.dismiss();
        }
    }

    onClickButton(d: DOData) {
        //on error return empty array
        this.selectedRow = new Array<DOData>();
        // find grid
        let lstGrid = this.listDocdata[0].filter(function (item) {
            return item.njDocDefTemplate.tType == "Grid"
        });
        //find zip code data
        let lstGridData: Array<NJDocData> = new Array<NJDocData>();
        if (lstGrid.length == 1) {
            //get grid data
            lstGridData = lstGrid[0].lstDocData;
            // get selected row from col of zip key and value selected
            // find template of key from template code in custom paramater
            let templateCodeKey = lstGrid[0].customParameters.KeyColumnField;
            let lstTemplate = lstGrid[0].lstChildDocDefTemplate.filter(function (item) {
                return item.templateCode == templateCodeKey;
            });
            if (lstTemplate.length == 1) {
                // find template id of key
                let docDefTemplateID = lstTemplate[0].docDefTemplateID;
                // get NJDocData of selected item 
                let lstdata = lstGridData.filter(function (item) {
                    return item.docDefTemplateID == docDefTemplateID && item.dataValue == d.njDocData.dataValue;
                });
                // get the selected row using docDefDataRowParID
                if (lstdata.length == 1) {
                    //selected row cleared above
                    for (var item of lstGridData) {
                        if (item.docDefDataRowID == lstdata[0].docDefDataRowID) {
                            let doData = new DOData();
                            doData.njDocData = item;
                            let lstTemplate = lstGrid[0].lstChildDocDefTemplate.filter(function (item1) {
                                return item1.docDefTemplateID == item.docDefTemplateID;
                            });
                            if (lstTemplate.length == 1) {
                                doData.njDocDefTemplate = lstTemplate[0];
                            }
                            doData.njDocDefTemplate
                            this.selectedRow.push(doData);
                        }
                    }
                }
            }
        }
    }

}
